import * as actions from "./actionsType";

const initialData = {
  loading: false,  
  loadingById: false,
  saveLoading: false,

  loadingCourse: false,
  loadingCourseById: false,
  saveLoadingCourse: false,

  loadingTask: false,
  loadingTaskById: false,
  saveLoadingTask: false,

  coursesFuncionLength: 0,
  coursesFuncion: [],
  courseFuncion: {},
  courseFuncionError: "",
  
  formError: "",
  coursesLength: 0,
  courses: [],
  course: {},
  tasks: [],
  tasksLength: 0,
  tasksError: "",
  courseFuncionError: "",
};

export default function CourseFuncionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COURSEFUNCION:
        return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_COURSEFUNCION:
        return { ...state, saveLoading: action.payload };
    case actions.GET_COURSEFUNCION:
        return {
            ...state,
            coursesFuncion: action.payload.coursesFuncion,
            coursesFuncionLength: action.payload.coursesFuncionLength,
        };
    case actions.GET_COURSEFUNCION_BY_ID:
      return { ...state, courseFuncion: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
      case actions.COURSEFUNCION_FAIL:
        return { ...state, courseFuncionError: action.payload };
  
      //Cursos
    case actions.LOADING_COURSE:
      return { ...state, loadingCourse: action.payload };

    case actions.LOADING_COURSE_BY_ID:
      return { ...state, loadingCourseById: action.payload };

    case actions.SAVE_LOADING_COURSE:
      return { ...state, saveCourseLoading: action.payload };

    case actions.GET_COURSE:
      return {
        ...state,
        courses: action.payload.courses,
        coursesLength: action.payload.coursesLength,
      };
    case actions.GET_COURSE_BY_ID:
      return { ...state, course: action.payload };

      case actions.LOADING_TASK:
        return { ...state, loadingTask: action.payload };
      case actions.SAVE_LOADING_TASK:
        return { ...state, saveLoadingTask: action.payload };
      case actions.GET_TASKS:
        return {
          ...state,
          tasks: action.payload.tasks,
          tasksLength: action.payload.tasksLength,
        };
    default:
        return state;
  }
}
